'use strict';

angular.module('DoohApps').factory('Account', ['restApi', function (restApi) {
    var controllerName = 'Account/';

    return {
        login: function (successCallback, failCallback, data) {
                restApi.LoginMethod(successCallback, failCallback, data);
        },
            logout: function (successCallback) {
                restApi.PostApiMethod(successCallback, controllerName + 'Logout');
            },
            getUserByInviteCode: function (successCallback, data) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetUserByInviteCode', data);
            },
            getProfile: function (successCallback) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetProfile');
            },
            getAccountInfo: function (successCallback) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetAccountInfo');
            },
            changePassword: function (successCallback, data) {
                restApi.PostApiMethod(successCallback, controllerName + 'ChangePassword', data);
            },
            sendInvitation: function (successCallback, data) {
                restApi.PostApiMethod(successCallback, controllerName + 'SendInvitation', data);
            },
            sendRegistrationRequest: function (successCallback, data) {
                restApi.PostApiMethod(successCallback, controllerName + 'SendRegistrationRequest', data);
            },
            register: function (successCallback, data) {
                restApi.PostApiMethod(successCallback, controllerName + 'Register', data);
            },
            updateProfileImage: function (successCallback, data) {
                restApi.PostApiMethod(successCallback, controllerName + 'UpdateProfileImage', data);
            },
            deleteProfileImage: function (successCallback) {
                restApi.PostApiMethod(successCallback, controllerName + 'DeleteProfileImage');
            },
            getNewPassword: function (successCallback, data) {
                restApi.PostApiMethod(successCallback, controllerName + 'GetNewPassword', data);
            },
            checkEmail: function (successCallback, data) {
            restApi.GetApiMethod(successCallback, controllerName + 'CheckEmail', { email: data });
            },
            getNewPasswordLink: function (successCallback, data) {
                restApi.PostApiMethod(successCallback, controllerName + 'GetNewPasswordLink', data);
            },
            resetNewPassword: function (successCallback, data) {
                restApi.PostApiMethod(successCallback, controllerName + 'ResetNewPassword', data);
            },
            updateUserDetails: function (successCallback, data) {
                restApi.PostApiMethod(successCallback, controllerName + 'UpdateUserDetails', data);
            },
            updatePersonStatus: function (successCallback, person) {
                restApi.PutApiMethod(successCallback, controllerName + 'PutPersonAndStatus', person);
            },
            setTimeZone: function (successCallback, zone) {
                restApi.GetApiMethod(successCallback, controllerName + 'SetTimeZone', { timeZone: zone }, true);
            },
            resendActivation: function (successCallback, personID) {
            restApi.PostApiMethod(successCallback, controllerName + 'ResendActivation?person=' + personID);
            },
        getNewPasswordLinkAdmin: function (successCallback, personID) {
            restApi.PostApiMethod(successCallback, controllerName + 'GetNewPasswordLink?userID=' + personID);
        },
            isAuthenticated: function (successCallback) {
                restApi.CheckSessionStatusMethod(successCallback, 'IsAuthenticated');
            },
            resendActivationemail: function (successCallback, email) {
                restApi.PostApiMethod(successCallback, controllerName + 'ResendActivation?email=' + email);
            },
            setLastUsedVersion: function (successCallback, personID, version) {
                restApi.PostApiMethod(successCallback, controllerName + 'SetLastUsedVersion?personId=' + personID + '&version=' + version);
            },
            changeLanguage: function (successCallback, language) {
                restApi.PostApiMethod(successCallback, controllerName + 'ChangeLanguage?language=' + language);
        },
        }
    }]);